module.exports = __webpack_public_path__ + "static/media/background.b439832d.jpg";